import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d48813c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "interest-rates-table mt-1" }
const _hoisted_2 = { class: "white-gradient" }
const _hoisted_3 = ["tabindex"]
const _hoisted_4 = {
  key: 0,
  id: "primaryHeader"
}
const _hoisted_5 = { class: "w-100" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "interest-rates-table__table-cell add-right-border w-15 text-nowrap font-weight-normal"
}
const _hoisted_8 = {
  key: 1,
  class: "interest-rates-table__table-cell add-right-border w-15 text-nowrap font-weight-normal text-gray"
}
const _hoisted_9 = { class: "d-flex" }
const _hoisted_10 = { class: "text-black" }
const _hoisted_11 = {
  key: 2,
  class: "interest-rates-table__table-cell add-right-border w-15 text-nowrap font-weight-normal"
}
const _hoisted_12 = { class: "d-flex" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("table", {
  id: "secondaryTable",
  class: "table mb-0 d-none sticky-header"
}, null, -1))
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["aria-label"]
const _hoisted_16 = ["aria-label"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "m-0" }, null, -1))
const _hoisted_19 = [
  _hoisted_18
]

import '@aab/sc-aab-icon';
import { comparePeriods, formatPercentage, getFixedPeriodInYears, isDefined } from '@/utils';
import { computed, onMounted, reactive } from 'vue';
import { InterestPeriodType, RiskCategoryType } from '@shared/constants';
import type { Period, PeriodRate } from '@shared/models';
import { sy_arrow_chevron_down as syArrowChevronDown, sy_arrow_chevron_up as syArrowChevronUp } from '@aab/sc-aab-icon-set';
import IText from '@/components/IText/IText.vue';
import { RateType } from '@shared/models';
import ScAnalyticsApi from '@aab/sc-analytics-api';
import { showSecondaryHeader } from './OffsetHelper';
import { translate } from '@/i18n';
import type { TranslateResult } from 'vue-i18n';
import { useI18nStore } from '@/stores/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'InterestRatesTable',
  props: {
    interestPeriods: { default: () => [] },
    shownInterestPeriods: { default: () => [] },
    headerLabels: { default: () => [] },
    usedRateCategories: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { interestPeriods: ReadonlyArray<Period>, shownInterestPeriods: ReadonlyArray<number>, headerLabels: ReadonlyArray<string>, usedRateCategories: ReadonlyArray<RateType | RiskCategoryType> };



const state = reactive({
  interestPeriodsFilter: props.shownInterestPeriods as ReadonlyArray<any> | undefined,
  iframeSrcUrl: undefined as any
});

onMounted(() => {
  getSecondaryTableHeader();
  window.parent.addEventListener('scroll', () => showSecondaryHeader((url: string) => (state.iframeSrcUrl = url)));
  window.parent.addEventListener('resize', () => {
    getSecondaryTableHeader();
    showSecondaryHeader((url: string) => (state.iframeSrcUrl = url));
  });
});

const sortedInterestPeriods = computed((): ReadonlyArray<Period> => {
  return [...props.interestPeriods].sort(comparePeriods);
});

const interestNotInactive = computed((): ReadonlyArray<Period> => {
  return sortedInterestPeriods.value.filter((interestPeriod) => interestPeriod.inactive === false);
});

const filteredInterestPeriods = computed((): ReadonlyArray<Period> => {
  if (isDefined(state.interestPeriodsFilter) && state.interestPeriodsFilter.length > 0) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return interestNotInactive.value.filter((period: Period) => state.interestPeriodsFilter!.indexOf(getFixedPeriodInYears(period)) > -1);
  }
  return sortedInterestPeriods.value;
});

function showAllInterestPeriods(): void {
  ScAnalyticsApi.eventTrack({
    eventName: 'click',
    eventCategory: 'interest rates table',
    eventAction: 'irt: show all terms clicked'
  });
  state.interestPeriodsFilter = undefined;
  const primaryTable = document.getElementById('primaryTable');
  if (primaryTable) primaryTable.focus();
}

function showDefaultInterestPeriods(): void {
  ScAnalyticsApi.eventTrack({
    eventName: 'click',
    eventCategory: 'interest rates table',
    eventAction: 'irt: show fewer terms clicked'
  });

  state.interestPeriodsFilter = props.shownInterestPeriods;
}

function getValue(expectedRateCategory: RateType | RiskCategoryType, interestRates: ReadonlyArray<PeriodRate>): string {
  const matchedInterestRate = interestRates.filter(({ ltv, type }) => (ltv || type) === expectedRateCategory);
  return matchedInterestRate.length > 0 ? matchedInterestRate[0].value : translate('text:notApplicable');
}

function getConsiderationPeriodItext(fixedPeriodInYears: number): TranslateResult {
  return Number(fixedPeriodInYears) !== 2 ? translate('iText:considerationPeriod') : translate('iText:considerationPeriodTwoYears');
}

function getSecondaryTableHeader(): void {
  const primaryHeader = document.getElementById('primaryHeader');
  if (primaryHeader) {
    const primaryTableHeadClone = primaryHeader.cloneNode(true);
    const secondaryTable = document.getElementById('secondaryTable');
    if (secondaryTable) {
      if (secondaryTable.hasChildNodes()) {
        if (secondaryTable.firstChild) secondaryTable.removeChild(secondaryTable.firstChild);
      }
      secondaryTable.appendChild(primaryTableHeadClone);
    }
  }
}

function isScrollable(): boolean {
  return props.headerLabels.length > 2;
}

return (_ctx: any,_cache: any) => {
  const _component_aab_link = _resolveComponent("aab-link")!
  const _component_aab_icon = _resolveComponent("aab-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["align-header", { 'scrollable-table': isScrollable(), 'table-overflow': !isScrollable() }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("table", {
          id: "primaryTable",
          class: "table mb-0",
          tabindex: state.interestPeriodsFilter ? -1 : 0
        }, [
          (__props.headerLabels && __props.headerLabels.length > 0)
            ? (_openBlock(), _createElementBlock("thead", _hoisted_4, [
                _createElementVNode("tr", _hoisted_5, [
                  _createElementVNode("th", {
                    class: _normalizeClass(["interest-rates-table__table-header -term remove-top-border text-nowrap add-right-border font-weight-normal w-15 text-heavy-green", { 'w-27-20': !isScrollable() }])
                  }, _toDisplayString(_ctx.$t('label:term')), 3),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.headerLabels, (header, index) => {
                    return (_openBlock(), _createElementBlock("th", {
                      key: index,
                      class: _normalizeClass(["interest-rates-table__table-header remove-top-border font-weight-normal w-15 text-heavy-green", { 'text-nowrap': isScrollable() }])
                    }, _toDisplayString(header), 3))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(filteredInterestPeriods) && _unref(filteredInterestPeriods).length > 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredInterestPeriods), (interestPeriod, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    (interestPeriod.type === _unref(InterestPeriodType).Variable)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_7, _toDisplayString(_ctx.$t('text:variable')), 1))
                      : _createCommentVNode("", true),
                    (interestPeriod.inactive === true)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createTextVNode(_toDisplayString(interestPeriod.type === _unref(InterestPeriodType).Euribor ? _ctx.$t('text:euribor') : _ctx.$t('text:months', { duration: interestPeriod.duration })) + " ", 1),
                            _createVNode(IText, {
                              class: "itext-dropdown ml-1",
                              name: 'euribor',
                              "with-offset": true
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_10, _toDisplayString(interestPeriod.type === _unref(InterestPeriodType).Euribor ? _ctx.$t('iText:euribor') : _ctx.$t(`iText:months-${interestPeriod.duration}`)), 1),
                                (interestPeriod.type === _unref(InterestPeriodType).Euribor)
                                  ? (_openBlock(), _createBlock(_component_aab_link, {
                                      key: 0,
                                      target: "_blank",
                                      url: _ctx.$t('linkUrl:euribor'),
                                      rel: "noopener noreferrer"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('linkText:euribor')), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["url"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (interestPeriod.type === _unref(InterestPeriodType).Fixed && interestPeriod.inactive === false)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createTextVNode(_toDisplayString(`${_unref(getFixedPeriodInYears)(interestPeriod)} ${_ctx.$t('text:year')}`) + " ", 1),
                            (interestPeriod.reflectionPeriod && Number(interestPeriod.reflectionPeriod) !== 0)
                              ? (_openBlock(), _createBlock(IText, {
                                  key: 0,
                                  class: "ml-1 table-itext",
                                  name: `consideration period ${_unref(getFixedPeriodInYears)(interestPeriod)}`,
                                  "with-offset": true
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(getConsiderationPeriodItext(_unref(getFixedPeriodInYears)(interestPeriod))), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["name"]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.usedRateCategories, (expectedRateCategory, idx) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: idx,
                        class: _normalizeClass(["interest-rates-table__table-cell w-15 text-nowrap font-weight-normal text-gray", { 'text-black': interestPeriod.inactive !== true }])
                      }, _toDisplayString(_unref(formatPercentage)(getValue(expectedRateCategory, interestPeriod.rates), _unref(useI18nStore)().locale)), 3))
                    }), 128))
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ], 8, _hoisted_3),
        _hoisted_13
      ])
    ], 2),
    (__props.shownInterestPeriods.length < __props.interestPeriods.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          (state.interestPeriodsFilter)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                id: "table-extend-btn",
                type: "button",
                "aria-label": _ctx.$t('label:showAllTerms'),
                class: "interest-rates-table__btn list-group-item extend-button text-heavy-green d-flex justify-content-center",
                tabindex: "0",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showAllInterestPeriods())),
                onKeydown: [
                  _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (showAllInterestPeriods()), ["prevent"]), ["space"])),
                  _cache[2] || (_cache[2] = _withKeys(($event: any) => (showAllInterestPeriods()), ["enter"]))
                ]
              }, [
                _createVNode(_component_aab_icon, {
                  svg: _unref(syArrowChevronDown),
                  size: "3"
                }, null, 8, ["svg"]),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('label:showAllTerms')), 1)
              ], 40, _hoisted_15))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                "aria-label": _ctx.$t('label:showFewerTerms'),
                class: "interest-rates-table__btn list-group-item extend-button text-heavy-green d-flex justify-content-center",
                tabindex: "0",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (showDefaultInterestPeriods())),
                onKeydown: [
                  _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event: any) => (showDefaultInterestPeriods()), ["prevent"]), ["space"])),
                  _cache[5] || (_cache[5] = _withKeys(($event: any) => (showDefaultInterestPeriods()), ["enter"]))
                ]
              }, [
                _createVNode(_component_aab_icon, {
                  svg: _unref(syArrowChevronUp),
                  size: "3"
                }, null, 8, ["svg"]),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('label:showFewerTerms')), 1)
              ], 40, _hoisted_16))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
  ]))
}
}

})